module.exports = __webpack_public_path__ + "img/reduce-downtime-depth1.f342da32.webp";